import React, { Component } from 'react';
import { connect } from 'react-redux';
import classes from './PaymentType.css';
import { checkValidity } from '../../../shared/utility';

class PaymentType extends Component {
    state = {
        cashAmount: {                
            validation: {
                required: false,
                isNumeric: true
            }
        },
        checkAmount: {                
            validation: {
                required: false,
                isNumeric: true
            }
        },
        checkNumber: {                  
            
        }
    }

    handleOptionChange = (event) => {
        if (this.props.paymentStatus != event.target.value)
        {
            this.props.onDataChanged('paymentStatus',event.target.value);
            this.props.onDataChanged('paymentStatus_touched',true);
            if (event.target.value == 'unpaid')
            {
                this.props.onDataChanged('cashAmount',0);
                this.props.onDataChanged('cashAmount_valid',true);
                this.props.onDataChanged('checkAmount',0);
                this.props.onDataChanged('checkAmount_valid',true);
                this.props.onDataChanged('checkNumber','');
                this.props.onDataChanged('checkNumber_valid',true);
            }            
        }
      }

      cashChanged = (event) => {
        this.props.onDataChanged('cashAmount_touched',true);
        let val = event.target.value;
        if (val == undefined)
        {
            val = 0;
        }
        this.props.onDataChanged('cashAmount',val);
        if (checkValidity(val,this.state.cashAmount.validation))
        {            
            this.props.onDataChanged('cashAmount_valid',true);
        }
        else
        {
            this.props.onDataChanged('cashAmount_valid',false);
        }
          
      }

      checkChanged = (event) => {
        this.props.onDataChanged('checkAmount_touched',true);
        let val = event.target.value;
        if (val === undefined)
        {
            val = 0;
        }
        
        this.props.onDataChanged('checkAmount',val);
        
        if (val === 0 && this.props.checkNumber !== '')
        {
            this.props.onDataChanged('checkAmount_valid',false);
        }
        else
        {        
            if (checkValidity(val,this.state.checkAmount.validation))
            {
                
                this.props.onDataChanged('checkAmount_valid',true);
                if (this.props.checkNumber === '')            {
                    this.props.onDataChanged('checkNumber_valid',false);
                    this.props.onDataChanged('checkNumber_touched',true);
                }
            }
            else
            {
                this.props.onDataChanged('checkAmount_valid',false);
            }
        }

    }

        checkNumberChanged = (event) => {
            this.props.onDataChanged('checkNumber_touched',true);
            this.props.onDataChanged('checkNumber',event.target.value);

            if (event.target.value !== '' && +this.props.checkAmount < 1)
            {
                this.props.onDataChanged('checkAmount_valid',false);
                this.props.onDataChanged('checkAmount_touched',true);
            }
            if (event.target.value === '' && this.props.checkAmount > 0)
            {
                this.props.onDataChanged('checkNumber_valid',false);
            }
            else
            {                
                this.props.onDataChanged('checkNumber_valid',true);
            }
            
    }

    formatNumber(value) {
        if (!value || value == '') {
          return '0.00';
        }
        else {
          return parseFloat(value).toFixed(2);
        }
      }

    render () {

        const cashClasses = [classes.InputElement];
        const checkClasses = [classes.InputElement];
        const checkNumberClasses = [classes.InputElement];
        if (!this.props.cashAmount_valid && this.props.cashAmount_touched) {
            cashClasses.push(classes.Invalid);
        }
        if (!this.props.checkAmount_valid && this.props.checkAmount_touched) {
            checkClasses.push(classes.Invalid);
        }
        if (!this.props.checkNumber_valid && this.props.checkNumber_touched) {
            checkNumberClasses.push(classes.Invalid);
        }

        return (
            <div className={classes.PaymentType}>
                <h4>Payment Information</h4>
                <div className={classes.Inline}>
                    <label className={classes.Label}>
                        Customer Paid
                    </label>
                    <div className="radio">
                        <label>
                            <input type="radio" value="paid" checked={this.props.paymentStatus === 'paid'}  onChange={this.handleOptionChange} />
                            Yes
                        </label>
                    
                        <label>
                            <input type="radio" value="unpaid" checked={this.props.paymentStatus === 'unpaid'}  onChange={this.handleOptionChange}/>
                            No
                        </label>
                    </div>    
                </div>
                <div>
                    <div className={classes.PayAmounts}>
                        <label className={classes.Label}>Cash</label>
                        <input className={cashClasses.join(' ')} placeholder="0.00" type="number" disabled={this.props.paymentStatus !== 'paid'} onChange={this.cashChanged} value={this.formatNumber(this.props.cashAmount)} />
                    </div>
                    <div className={classes.PayAmounts}>
                        <label className={classes.Label}>Check</label>
                        <input className={checkClasses.join(' ')} placeholder="0.00" type="number" disabled={this.props.paymentStatus !== 'paid'} onChange={this.checkChanged} value={this.formatNumber(this.props.checkAmount)} />
                    </div>
                    <div className={classes.PayAmounts}>
                        <label className={classes.Label}>Check #</label>
                        <input className={checkNumberClasses.join(' ')} placeholder="" type="number" disabled={this.props.paymentStatus !== 'paid'} onChange={this.checkNumberChanged} value={this.props.checkNumber} />
                    </div>
                </div>
            </div>
        );
    }
};


const mapStateToProps = state => {
    return {
        paymentStatus: state.orders.order.paymentStatus,
        cashAmount: state.orders.order.cashAmount,
        cashAmount_valid: state.orders.order.cashAmount_valid,
        cashAmount_touched: state.orders.order.cashAmount_touched,
        checkAmount: state.orders.order.checkAmount,
        checkAmount_valid: state.orders.order.checkAmount_valid,
        checkAmount_touched: state.orders.order.checkAmount_touched,
        checkNumber: state.orders.order.checkNumber,
        checkNumber_valid: state.orders.order.checkNumber_valid,
        checkNumber_touched: state.orders.order.checkNumber_touched,
        isAuthenticated: state.orders.token !== null
    };
}


export default connect(mapStateToProps)( PaymentType);


// WEBPACK FOOTER //
// ./src/components/Order/PaymentType/PaymentType.js